export class IsVisibleOnFormBaseValueConverter {
    toView(array) {
        return array.filter((item) => item.hasOwnProperty('IsVisibleOnForm') && item.IsVisibleOnForm == true);
    }
}